module.exports = __webpack_public_path__ + "img/card.92906e4e.svg";